import { useState, useEffect, useRef } from 'react';
import {
  Box,
  ImageList,
  ImageListItem,
  Typography,
  ImageListItemBar,
  LinearProgress,
  CircularProgress,
  Paper,
  IconButton,
} from '@mui/material';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import { useStore } from '../../utils/store';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import HttpServices from '../../services/HttpService';
import Constants from '../../utils/constants';
import { base64ToFile, getFormatDate } from '../../utils/storageUtil';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import { useNavigate, useParams } from 'react-router-dom';
import CustomPaginationActionsTable from '../../components/TablePagination';
import RefreshIcon from '@mui/icons-material/Refresh';

import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import SignatureCanvas from 'react-signature-canvas';
const ShiftSiteMemo: React.FC = ({}) => {
  const navigate = useNavigate();
  const isInitialLoad = useRef(true);
  const { crewId, shiftId } = useParams<{ crewId: any; shiftId: any }>();
  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const { getAdmin } = useStore();
  const [itemData, setItemData] = useState<any[]>([]);
  const [siteMemoDialogOpen, setSiteMemoDialogOpen] = useState(false);
  const [canvasError, setCanvasError] = useState<any>('');
  const [siteMemoError, setSiteMemoError] = useState<any>('');
  const [fileDownloading, setFileDownloading] = useState<number[]>([]);
  const [currentNote, setCurrentNote] = useState('');
  const [saving, setSaving] = useState(false);

  const sigCanvas: any = useRef({});
  const columns: any[] = [
    {
      field: 'notes',
      headerName: 'Notes',
    },
    {
      field: 'created',
      headerName: 'Date',
      renderCell: (value: any, row: any) => getFormatDate(value),
    },
    {
      field: 'document',
      headerName: 'Document',
      width: '100px',
      renderCell: (value: any, row: any) =>
        value ? (
          <IconButton
            onClick={() => {
              handleDownloadFile(row.id);
            }}
            disabled={fileDownloading.includes(row.id)}
          >
            {fileDownloading.includes(row.id) ? (
              <CircularProgress size={20} />
            ) : (
              <AttachFileIcon />
            )}
          </IconButton>
        ) : (
          <Box>-</Box>
        ),
    },
  ];

  const handleDownloadFile = async (siteMemoId: number) => {
    try {
      setFileDownloading((prev) => [...prev, siteMemoId]);
      const URL = `${Constants.apiURL}${Constants.documentPDFsURL}/fetchShiftSiteMemoPDF/${siteMemoId}`;
      const response = await HttpServices.get(URL, {
        headers: {
          Authorization: 'Bearer ' + getAdmin(),
          Accept: 'application/pdf',
        },
        responseType: 'blob',
      });

      if (response) {
        const fileName = 'SiteMemo-' + siteMemoId + '.pdf';
        const blob = new Blob([response], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }
      setFileDownloading((prev) => prev.filter((id) => id !== siteMemoId));
    } catch (error: any) {
      setFileDownloading((prev) => prev.filter((id) => id !== siteMemoId));
      console.error(`GET ERROR:`, error);
    }
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (itemData.length === 0) fetchData();
    }
  }, [shiftId]);

  const fetchData = async () => {
    try {
      setInProgress(true);
      const response = await HttpServices.get(
        `${Constants.apiURL}${Constants.photoURL}/sitememo`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: shiftId,
          search: '',
          limit: -1,
          offset: 0,
        }
      );
      if (response.success) {
        setItemData(response.data.paginateRecords);
      }
      console.log('GET Response:', response);
      setInProgress(false);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: 'No records found',
        open: true,
      });
      setInProgress(false);
    }
  };
  const clearSignature = () => {
    sigCanvas.current.clear();
  };
  const handleNoteSave = async () => {
    let dataUrl: any = '';
    if (!sigCanvas.current.isEmpty()) {
      //  console.log(sigCanvas.current.toDataURL('image/png'));
      dataUrl = sigCanvas.current.toDataURL('image/png');
    } else {
      setCanvasError('required field');
      return false;
    }
    if (!currentNote) {
      setSiteMemoError('Note is requied');
      return;
    }
    if (dataUrl !== '') {
      setSaving(true);
      const file = base64ToFile(dataUrl);
      const apiUrl = `${Constants.apiURL}${Constants.photoURL}/sitememo/uploadSignedURL`;
      const signedData: any = await HttpServices.handlePresignedDocument(
        file,
        'sitememo',
        shiftId,
        getAdmin(),
        apiUrl
      );
      console.log(`signedData`);
      console.log(signedData);
      console.log(`signedData`);
      const response: any = await HttpServices.post(
        Constants.apiURL + Constants.photoURL + '/sitememo?id=' + shiftId,
        {
          notes: currentNote,

          filePath: signedData.filePath,
          fileName: signedData.fileName,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getAdmin(),
          },
        }
      );
      setSaving(false);
      setAlert({
        type: 'success',
        message: 'Saved Sucessfully',
        open: true,
      });
      setSiteMemoDialogOpen(false);
      clearSignature();
      setCurrentNote('');
      fetchData();
    }
  };
  const NoteDialogContent = () => {
    return (
      <div className="row mb-3 mt-2">
        <Box sx={{ width: '600px' }}>
          <Box>
            <TextFieldAreaComponent
              name={'notebox_'}
              value={currentNote}
              isRequired={true}
              errorStr={siteMemoError}
              minRows={7}
              keyName={'notebox_'}
              label="Note"
              onChange={(e: any) => {
                setCurrentNote(e.target.value);
                setSiteMemoError('');
              }}
            />
          </Box>
          <Box>Draw a Signatue</Box>
          <Paper
            sx={{
              border: '1px solid #dedede',
              position: 'relative',
              marginTop: '5px',
            }}
          >
            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{ width: 600, height: 200, className: 'sigCanvas' }}
            />
            <IconButton
              onClick={clearSignature}
              sx={{ float: 'right', position: 'absolute', right: 0, bottom: 0 }}
            >
              <RefreshIcon />{' '}
            </IconButton>
          </Paper>
          {canvasError && (
            <Box sx={{ color: 'red' }}>Signature is required</Box>
          )}
        </Box>
        <div className="col" style={{ textAlign: 'right', marginTop: '15px' }}>
          <ButtonComponent
            keyName={'addBtn'}
            errors={[]}
            onClick={handleNoteSave}
            loading={saving}
            disabled={saving}
            label={saving ? 'Saving...' : 'Save'}
          />
        </div>
      </div>
    );
  };
  return (
    <Box className="main dashboardmain">
      <Box
        sx={{ width: '100%', padding: '20px' }}
        className="section dashboard"
      >
        <Box
          className="containergrid"
          sx={{
            padding: ' 16px',
          }}
        >
          {
            <Box>
              <Box
                onClick={() => {
                  navigate(
                    '/schedules/crews-schedule/' + crewId + '/' + shiftId
                  );
                }}
                style={{
                  cursor: 'pointer',
                  display: 'inline-flex',
                  gap: '8px',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <UTurnLeftIcon
                  sx={{
                    transform: 'rotate(90deg)',
                    cursor: 'pointer',
                  }}
                />
                <Typography>Back</Typography>
              </Box>
              <Paper sx={{ width: '100%', mt: 4 }} className="mt-4">
                <Box
                  sx={{
                    padding: '24px 16px 16px 16px',
                    mb: 2,
                    display: 'grid',
                    gap: '32px',
                    overflowX: 'scroll',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography
                      component={'h6'}
                      sx={{ mt: 4, fontWeight: '500' }}
                    >
                      {'Site Memo'}
                    </Typography>
                    {inProgress && (
                      <Box sx={{ width: '100%', textAlign: 'center' }}>
                        <CircularProgress sx={{ color: 'rgb(0, 244, 255)' }} />
                      </Box>
                    )}
                    <AddButtonComponent
                      onClick={() => {
                        setSiteMemoDialogOpen(true);
                      }}
                      keyName="checkIcon"
                      label="Add Site Memo"
                    />
                  </Box>
                  <Box>
                    <CustomPaginationActionsTable
                      rows={itemData}
                      columns={columns}
                      totalRecords={itemData.length}
                      handlePagination={() => {}}
                      handleRowClick={(row) => {}}
                      paginationModel={{
                        page: 0,
                        pageSize: -1,
                      }}
                      handleStatus={() => {}}
                      isPagingHide={true}
                    />
                  </Box>
                </Box>
              </Paper>
            </Box>
          }
        </Box>
        <SimpleDialogComponent
          title={'Site Memo'}
          dialogContent={NoteDialogContent()}
          open={siteMemoDialogOpen}
          handleClose={() => {
            setSiteMemoDialogOpen(false);
          }}
        />
        <AlertMessageComponent
          type={alert.type}
          open={alert.open}
          handleClose={handleCloseAlert}
          message={alert.message}
        />
      </Box>
    </Box>
  );
};
export default ShiftSiteMemo;
